import type { ChosenMode } from "../api";

const baseStyle: React.CSSProperties = {
  display: "inline-block",
  padding: "4px 10px",
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.04em",
  color: "#fff",
  borderRadius: 999,
  textTransform: "uppercase",
};

export const RouteBadge = ({ mode }: { mode?: ChosenMode | null }) => {
  const isGrid = mode === "grid_review";
  return (
    <span
      style={{
        ...baseStyle,
        background: isGrid ? "var(--ir-blue)" : "var(--ir-sage)",
      }}
    >
      {isGrid ? "Grid" : "Engineer"}
    </span>
  );
};
